"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invitationTypeEpics = exports.saveInvitationTypeEpic = exports.getInvitationTypesEpic = exports.initInvitationTypesEpic = exports.backToInvitationTypeEpic = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _ramda = require("ramda");

var _gift = require("../gift.selector");

var _gift2 = require("../gift.types");

var _constants = require("../../../constants");

var actions = _interopRequireWildcard(require("./invitationType.actions"));

var helpers = _interopRequireWildcard(require("./invitationType.helpers"));

var selectors = _interopRequireWildcard(require("./invitationType.selectors"));

// TODO: Remove it when gift reducer will be split
var backToInvitationTypeEpic = function backToInvitationTypeEpic(action$) {
  return action$.pipe((0, _reduxObservable.ofType)(_gift2.GIFT_CREATE_EDIT_STEP), (0, _operators.filter)(function (_ref) {
    var payload = _ref.payload;
    return payload === _constants.steps.SELECT_INVITATION_TYPE;
  }), (0, _operators.map)(function () {
    return actions.editInvitationType();
  }));
};

exports.backToInvitationTypeEpic = backToInvitationTypeEpic;

var initInvitationTypesEpic = function initInvitationTypesEpic(action$) {
  return action$.pipe((0, _reduxObservable.ofType)(_gift2.GIFT_CREATE_LOAD_SUCCESS), (0, _operators.map)(function (_ref2) {
    var gift = _ref2.payload;
    return actions.initInvitationType(helpers.convertGiftToInvitationType(gift));
  }));
};

exports.initInvitationTypesEpic = initInvitationTypesEpic;

var getInvitationTypesEpic = function getInvitationTypesEpic(action$, state$, _ref3) {
  var createGiftService = _ref3.createGiftService,
      errorHandler = _ref3.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(actions.getInvitationTypes), (0, _operators.withLatestFrom)(state$.pipe((0, _operators.map)((0, _ramda.applySpec)({
    giftId: _gift.getGiftId
  })))), (0, _operators.mergeMap)(function (_ref4) {
    var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
        giftId = _ref5[1].giftId;

    return createGiftService.getAvailableInvitationTypes(giftId).pipe((0, _operators.mergeMap)(function (response) {
      return [actions.getInvitationTypesSuccess(helpers.convertInvitationTypes(response.gift_invitation_items))];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.getInvitationTypesFail
    })));
  }));
};

exports.getInvitationTypesEpic = getInvitationTypesEpic;

var saveInvitationTypeEpic = function saveInvitationTypeEpic(action$, state$, _ref6) {
  var createGiftService = _ref6.createGiftService,
      errorHandler = _ref6.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(actions.saveInvitationType), (0, _operators.withLatestFrom)(state$.pipe((0, _operators.map)((0, _ramda.applySpec)({
    invitationTypeId: selectors.getSelectedInvitationTypeId,
    giftId: _gift.getGiftId
  })))), (0, _operators.mergeMap)(function (_ref7) {
    var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
        _ref8$0$meta = _ref8[0].meta,
        returnAddress = _ref8$0$meta.returnAddress,
        deliveryAddress = _ref8$0$meta.deliveryAddress,
        _ref8$ = _ref8[1],
        invitationTypeId = _ref8$.invitationTypeId,
        giftId = _ref8$.giftId;

    return createGiftService.selectInvitationType(giftId, {
      gift_invitation_type_id: invitationTypeId,
      return_address: returnAddress,
      contact_address: deliveryAddress
    }).pipe((0, _operators.mergeMap)(function (response) {
      return [actions.saveInvitationTypeSuccess(helpers.convertInvitationType(response))];
    }), (0, _operators.catchError)(function (err) {
      return errorHandler({
        callbacks: actions.saveInvitationTypeFail,
        message: (0, _ramda.pathOr)('', ['errors', 'message'], err)
      })(err);
    }));
  }));
};

exports.saveInvitationTypeEpic = saveInvitationTypeEpic;
var invitationTypeEpics = [initInvitationTypesEpic, getInvitationTypesEpic, saveInvitationTypeEpic, backToInvitationTypeEpic];
exports.invitationTypeEpics = invitationTypeEpics;